import { firestore, functions } from '@/firebaseConfig'
import Message from '@/model/Message';
import UUIDUtils from '@/utils/UUIDUtils';
import PushNotification from '../model/PushNotification';
import LangUtils from '@/utils/LangUtils';

export default class MessagingService {

    // loadMessagesForUser(userId, publisherId, status, onlyDeleted = false, includeDeleted = false) {
    //     const promise = new Promise((resolve, reject) => {
    //         var query = firestore.collection("users").doc(userId).collection("messages");

    //         if (publisherId) {
    //             query = query.where("publisherId", "==", publisherId);
    //         }

    //         if (status) {
    //             query = query.where("status", "==", status);
    //         }

    //         if (onlyDeleted) {
    //             query = query.where("deleted", "==", true);
    //         } else if (!includeDeleted) {
    //             query = query.where("deleted", "==", false);
    //         }

    //         query.get().then((querySnapshot) => {
    //             const result = [];

    //             querySnapshot.forEach((doc) => {
    //                 result.push(new Message(doc.data()));
    //             });

    //             resolve(result);
    //         }).catch((error) => {
    //             reject(error);
    //         });
    //     });

    //     return promise;
    // }

    loadMessagesForUser(userId, publisherId, onlyLatest, onlyUnread = false, onlyDeleted = false, includeDeleted = false) {
        const promise = new Promise((resolve, reject) => {
            var query = firestore.collection("users").doc(userId).collection("messages").where("publisherId", "==", publisherId);
                
            if (onlyLatest) {
                query = query.where("read", "==", false).limit(5);
            } else if (onlyUnread) {
                query = query.where("read", "==", false);
            }
            
            if (onlyDeleted) {
                query = query.where("deleted", "==", true);
            } else if (!includeDeleted) {
                query = query.where("deleted", "==", false);
            }

            query = query.orderBy("receivedDate", "desc");

            query.get().then((querySnapshot) => {
                const result = [];

                querySnapshot.forEach((doc) => {
                    result.push(new Message(doc.data()));
                });

                resolve(result);
            }).catch((error) => {
                reject(error);
            });
        });

        return promise;
    }

    saveMessageForUser(userId, message) {
        const promise = new Promise((resolve, reject) => {
            if (!message.id) {
                message.id = UUIDUtils.generateUUID();
            }

            firestore.collection("users").doc(userId).collection("messages").doc(message.id).set(message.toJSON()).then(() => {
                resolve();
            }).catch((error) => {
                reject(error);
            });
        });

        return promise;
    }





    // saveMessageForPublisher(publisherId, message) {
    //     const promise = new Promise((resolve, reject) => {
    //         if (!message.id) {
    //             message.id = UUIDUtils.generateUUID();
    //         }

    //         firestore.collection("publishers").doc(publisherId).collection("messages").doc(message.id).set(message.toJSON()).then(() => {
    //             resolve();
    //         }).catch((error) => {
    //             reject(error);
    //         });
    //     });

    //     return promise;
    // }

    loadPushNotificationsForPublisher(publisherId) {
        const promise = new Promise((resolve, reject) => {
            firestore.collection("publishers").doc(publisherId).collection("pushNotifications").get().then((querySnapshot) => {
                const result = [];

                querySnapshot.forEach((doc) => {
                    result.push(new PushNotification(doc.data()));
                });

                resolve(result);
            }).catch((error) => {
                reject(error);
            });
        });

        return promise;
    }

    loadPushNotificationsForMap(publisherId, mapId) {
        const promise = new Promise((resolve, reject) => {
            firestore.collection("publishers").doc(publisherId).collection("pushNotifications").where("mapIds." + mapId, "==", true).get().then((querySnapshot) => {
                const result = [];

                querySnapshot.forEach((doc) => {
                    result.push(new PushNotification(doc.data()));
                });

                resolve(result);
            }).catch((error) => {
                reject(error);
            })
        });

        return promise;
    }

    savePushNotificationForPublisher(publisherId, pushNotification) {
        const promise = new Promise((resolve, reject) => {
            if (!pushNotification.id) {
                pushNotification.id = UUIDUtils.generateUUID();
            }

            firestore.collection("publishers").doc(publisherId).collection("pushNotifications").doc(pushNotification.id).set(pushNotification.toJSON()).then(() => {
                resolve();
            }).catch((error) => {
                reject(error);
            });
        });

        return promise;
    }

    deletePushNotificationForPublisher(publisherId, pushNotificationId) {
        return firestore.collection("publishers").doc(publisherId).collection("pushNotifications").doc(pushNotificationId).delete();
    }

    sendPushNotificationForMap(publisherId, publisherName, mapBundleId, mapId, notification) {
        const sendNotificationMessageToTopic = functions.httpsCallable("sendNotificationMessageToTopic");

        const allPromises = [];

        const enTopic = "publishers_" + publisherId + "_bundles_" + mapBundleId + "_maps_" + mapId + "_en";
        const frTopic = "publishers_" + publisherId + "_bundles_" + mapBundleId + "_maps_" + mapId + "_fr";

        const enPublisherName = publisherName ? LangUtils.valueForLanguage(publisherName, "en") : null; 
        const frPublisherName = publisherName ? LangUtils.valueForLanguage(publisherName, "fr") : null;

        var enTitle = LangUtils.valueForLanguage(notification.title, "en");
        var enMessage = LangUtils.valueForLanguage(notification.message, "en");
        if (enMessage != null) {
            enMessage = enPublisherName ? enPublisherName + ": " + enMessage : enMessage;
        } else {
            enMessage = enPublisherName ? enPublisherName + ": " + enTitle : enTitle;
        }

        var frTitle = LangUtils.valueForLanguage(notification.title, "fr");
        var frMessage = LangUtils.valueForLanguage(notification.message, "fr");
        if (frMessage != null) {
            frMessage = frPublisherName ? frPublisherName + ": " + frMessage : frMessage;
        } else {
            frMessage = frPublisherName ? frPublisherName + ": " + frTitle : frTitle;
        }

        const enPayload = {
            type: "publisher",
            publisherId: publisherId,
            bundleId: mapBundleId,
            mapId: mapId,
            id: notification.id,
            title: enTitle,
            message: enMessage
        };

        const frPayload = {
            type: "publisher",
            publisherId: publisherId,
            bundleId: mapBundleId,
            mapId: mapId,
            id: notification.id,
            title: frTitle,
            message: frMessage
        };

        allPromises.push(sendNotificationMessageToTopic({
            topic: enTopic,
            json: enPayload
        }));

        allPromises.push(sendNotificationMessageToTopic({
            topic: frTopic,
            json: frPayload
        }));

        return Promise.all(allPromises);
    }
}
